var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconActivityMinutes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.686429 4.34243C0.229268 3.89832 0.000458304 3.31626 6.85058e-07 2.7342C-0.000456934 2.15036 0.228353 1.56652 0.686429 1.12063C1.60121 0.230625 3.08481 0.230625 4.00005 1.12063C4.91483 0.230625 6.39843 0.230625 7.31367 1.12063C7.79966 1.59322 8.02755 2.22156 7.99735 2.84011C7.97035 3.38657 7.74246 3.92502 7.31367 4.34243L4.00005 7.56424L0.686429 4.34243Z",
    fill: "#006CFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActivityMinutes);
export default __webpack_public_path__ + "static/media/icon-activity-minutes.8e41107c682e2567b6debabe6f2b8dbd.svg";
export { ForwardRef as ReactComponent };